import React, { useCallback, useState, useEffect } from 'react';
import { useMediaQuery } from 'react-responsive';
import PropTypes from 'prop-types';

import Traductor from '../../Traductor';
import { formatNumber } from '../../../js/components/shared/vehicleFunctions';

const DetailsModalOptions = ({
    onChangeAmount,
    inputAmount,
    vehicle: {
        IdVehicle,
        IdPublish,
        batchStatus,
        AmountOffered,
        AmountReference,
        LastAmount,
    },
    containerClasses,
    loading,
    disabled,
}) => {
    const t = new Traductor();
    const isMobile = useMediaQuery({
        query: '(max-device-width: 600px)',
    });

    const [error, setError] = useState(false);

    const validateKey = useCallback(e => {
        if (e.key === 'Enter') {
            e.preventDefault();
            document.activeElement.blur();
        }
        if (
            e.key.charCodeAt() !== 65 && //enable keyboard arrows
            e.key.charCodeAt() !== 84 && //enable tab bar
            e.key.charCodeAt() !== 66 && //enable backspace
            (e.key.charCodeAt() < 48 || e.key.charCodeAt() > 57) //only numbers allowed
        )
            e.preventDefault();
    }, []);

    const formatThousands = useCallback(value => {
        if (!value) return value;

        //  replaceAll isn't supported in all browsers, using replace for better browser support
        const resetValue = value.toString().replace(/\./g, ''); //.replaceAll('.', '');

        return formatNumber(resetValue);
    }, []);

    const validateMultiple100 = useCallback(
        value => {
            if (!error && value % 100 !== 0) {
                setError(true);
            } else if (error && value % 100 === 0) {
                setError(false);
            }
        },
        [error]
    );

    useEffect(() => {
        if (!loading) validateMultiple100(inputAmount);
    }, [loading]);

    return (
        <div
            id="c-vehicle-prices-container"
            className={`o-layout__item  u-1/1 ${
                containerClasses ? containerClasses : ''
            }`}
        >
            {batchStatus !== '2' && batchStatus !== '4' && (
                <div className="c-vehicle-prices-input">
                    <label
                        htmlFor={`${IdVehicle}-price-input`}
                        style={{ display: 'block' }}
                    >
                        {t.getTraduction('Import')}
                    </label>
                    <div className="c-input u-pb">
                        <input
                            id={`${IdVehicle}-price-input`}
                            className={`c-input__input ${
                                error ? 'is-error' : ''
                            }`}
                            type={isMobile ? 'tel' : 'text'}
                            placeholder={
                                loading ? '' : t.getTraduction('PriceMax')
                            }
                            disabled={loading || disabled}
                            onKeyDown={validateKey}
                            onChange={e => {
                                !e.target.validity.valid && e.preventDefault();
                                const formattedThousands = formatThousands(
                                    e.target.value
                                );
                                e.target.value = formattedThousands;
                                onChangeAmount({
                                    IdPublish,
                                    amount: formattedThousands,
                                });
                                validateMultiple100(
                                    formattedThousands.replace(/\./g, '') //.replaceAll('.', ''); NOT SUPPORTED IN ALL BROWSERS YET
                                );
                            }}
                            defaultValue={formatThousands(inputAmount)}
                            title={
                                error
                                    ? t.getTraduction('MultipleNumberError')(
                                          100
                                      )
                                    : ''
                            }
                            pattern="[0-9]{1,5}"
                        />
                    </div>
                </div>
            )}
            <div className="o-inline-group u-m-none">
                {!loading && (
                    <>
                        {AmountReference ? (
                            <div
                                className="u-pr"
                                style={{
                                    display: 'inline-block',
                                    fontSize: '0.8rem',
                                }}
                            >
                                <p>{t.getTraduction('PriceReference')}</p>
                                <p className="u-h6 u-text-disabled">
                                    {!loading &&
                                        formatNumber(AmountReference) + '€'}
                                </p>
                            </div>
                        ) : null}
                        {LastAmount ? (
                            <div
                                style={{
                                    display: 'inline-block',
                                    fontSize: '0.8rem',
                                }}
                            >
                                <p>{t.getTraduction('ProposedAmount')}</p>
                                <p
                                    className="u-h6"
                                    style={{ color: '#4c5356' }}
                                >
                                    {formatNumber(LastAmount) + '€'}
                                </p>
                            </div>
                        ) : null}
                    </>
                )}
            </div>
        </div>
    );
};

DetailsModalOptions.propTypes = {
    onChangeAmount: PropTypes.func,
    inputAmount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    selectedVehicle: PropTypes.shape({
        IdVehicle: PropTypes.number,
        IdPublish: PropTypes.number,
        batchStatus: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        AmountOffered: PropTypes.number,
        AmountReference: PropTypes.number,
        LastAmount: PropTypes.number,
    }),
    containerClasses: PropTypes.string,
    loading: PropTypes.any,
    disabled: PropTypes.any,
};

export default DetailsModalOptions;
